import { Children } from 'react';
import clsx from 'clsx';
import { Header } from '../layouts';

export default function PageHeader({ className, children, ...rest }) {
  // 🚨 The second column is declared only when something fills it. A grid
  // declares every track it is given whether or not a child lands there, and
  // `gap-4` is reserved BEFORE the second one — so the screens that pass a
  // single child had their content stop 16px short of the header's right edge
  // while the table card below ran the full width. Measured on incoming
  // invoices: the filter bar ended at 1794px, the card beneath it at 1806px.
  //
  // ⚠️ Two tidier-looking fixes were measured and both broke something:
  //   · flex + `flex-1` on the first child — several headers give their
  //     right-hand group `w-full`, which under flex takes its basis from that
  //     and squeezes the left group to nothing (the employees screen collapsed
  //     its company filter from 771px to 8px);
  //   · keeping the separation as `ml-4` on the second child — that same
  //     `w-full` group then sizes to its track and overflows the header.
  // Sizing tracks rather than items is what makes `1fr auto` work here, so it
  // stays; only the track count is now conditional.
  const columns = Children.toArray(children).length;

  return (
    <Header className={clsx('page__header', className)} {...rest}>
      <div
        className={clsx(
          'grid w-full items-center justify-between',
          columns > 1 ? 'grid-cols-[1fr_auto] gap-4' : 'grid-cols-1'
        )}
      >
        {children}
      </div>
    </Header>
  );
}
